import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Link } from "gatsby";

const BreadcrumbsWrapper = styled.div`
  display: flex;
  gap: 0.2rem;
  margin: 0.875rem auto;
  font-size: 0.875rem;
  font-weight: 700;
  width: 100%;
  overflow-x: scroll;
  font-family: ${({ theme }) => theme.fontParagraphs.fontFamily};
  padding: 5px 15px 5px 0;
  white-space: nowrap;
  align-items: baseline;
`;
const BreadcrumbsText = styled.span`
  font-weight: 100;
  &:last-of-type {
    font-weight: 600;
    margin: 0 5px 0 0;
    font-style: italic;
  }
`;

const BreadcrumbsLink = styled(Link)`
  text-decoration: none;
  font-weight: 100;
  @media (hover: hover) {
    &:hover {
      text-decoration: underline;
    }
  }
`;
const InnerWrapper = styled.div`
  span {
    font-weight: 600;
    margin: 0 5px;
  }
  a {
    text-decoration: none;
    margin: 0 5px 0 0;
    font-weight: 100;
  }
`;

const Breadcrumbs = ({ crumbs, breadcrumbList }) => {
  return (
    <BreadcrumbsWrapper className="breadcrumbs-wrapper">
      {breadcrumbList && breadcrumbList.length > 0 ? (
        breadcrumbList.map((breadcrumb, i) => (
          <React.Fragment key={i}>
            {i > 0 && <span>{" / "}</span>}
            {i === breadcrumbList.length - 1 ? (
              <BreadcrumbsText
                dangerouslySetInnerHTML={{ __html: breadcrumb.text }}
              />
            ) : (
              <BreadcrumbsLink to={breadcrumb.url}>
                {breadcrumb.text}
              </BreadcrumbsLink>
            )}
          </React.Fragment>
        ))
      ) : (
        <InnerWrapper dangerouslySetInnerHTML={{ __html: crumbs }} />
      )}
    </BreadcrumbsWrapper>
  );
};

Breadcrumbs.propTypes = {
  crumbs: PropTypes.string,
  className: PropTypes.string,
  breadcrumbList: PropTypes.arrayOf(PropTypes.object),
};

Breadcrumbs.defaultProps = {
  breadcrumbList: [],
};

export default Breadcrumbs;
